import { Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

export const OrganisationAreaTitle = ({ children }: PropsWithChildren) => {
  return <Typography variant="h4">{children}</Typography>;
};
